var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('data-table',{attrs:{"table-ref":"progress-table","title":_vm.permitLabel,"icon":"fa fa-share-alt","hide-org-badge":_vm.hideBadge,"show-search":_vm.showSearch,"url":'/actions/site/' + _vm.rowData.id + '/null/prg',"fields":_vm.fields,"detail-component":"progress-detail-row"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }